/* unplugin-vue-components disabled */import script from "./ch2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ch2.vue?vue&type=script&setup=true&lang=ts"

import "./ch2.vue?vue&type=style&index=0&id=168122db&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-168122db"]])

export default __exports__